import messageallComponent from './message.all.component';

let messageallModule = angular.module('messageall', [
  ])

  .component('messageall', messageallComponent)

  .name;

export default messageallModule;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/message/all/index.js